<template>
   <question-wrapper :questionId="questionId">
        <question-header :title="title" />
        <question-text :explainer="explainer" :pass="pass" :fail="fail" :skip="skip" :callToAction="callToAction" v-on:doTest="showBrowserDetails" />

        <div class="result">
          <!-- Pass -->
          <pass-message :pass="pass" :skip="skip" :nextPage="nextPage" :previousPage="previousPage">
            <div slot="message">
              <p>
                <translate>We have detected that you are using</translate>&nbsp;<span class="browser-name">{{ usersBrowserName }}</span>,&nbsp;<translate>Version</translate>:&nbsp;<span class="browser-version">{{ usersBrowserVersion }}</span>
              </p>
              <p v-if="pass">
                <translate>Great news!</translate>&nbsp;
                <translate>Your browser is up-to-date and compatible!</translate>
              </p>
              <p v-if="skip">
                <translate>Browser test skipped.</translate>&nbsp;
                <translate>Support for this browser is experimental.</translate>
              </p>
            </div>
          </pass-message>

          <!-- Fail -->
          <browser-fail
            v-if="fail"
            :usersBrowserName="usersBrowserName"
            :usersBrowserVersion="usersBrowserVersion"
            :usersOperatingSystem="config.user.browser.os"
            :usersPlatform="config.user.browser.platform"
            :badBrowser="badBrowser"
            :oldBrowser="oldBrowser"
            :skipOption="browserSkip"
            :imageSize="64"
            @skipTest="skipBrowserTest"
          />


        </div>
    </question-wrapper>
</template>

<script>
  import BasePage from './common/BasePage.vue'
  import { mapState, mapMutations } from 'vuex'
  import BrowserFail from '@/../../shared/src/components/usersetup/BrowserFail.vue'
  import { unifiedBrowserCheck } from '@/../../shared/src/utils/browserCheck.js'
  /**
   * This is the _*Page*_ component that holds all the components and data necessary for doing the _*Browser*_ test.
   * Like all pages it has a header, an explanation of the test, a button to execute the test and messages to display when the test is complete
   */
  export default {
    name: 'Browser',
    mixins: [BasePage],

    components: {
      'browser-fail': BrowserFail
    },

    data () {
      return {
        'vuexModule': 'browser',
        'browserSkip': false
      }
    },

    computed: {

      ...mapState('browser', [
        'supportedBrowsers', 'oldBrowser', 'badBrowser'
      ])
    },

    methods: {

      ...mapMutations('browser', ['setBadBrowser', 'setOldBrowser', 'start']),

      /**
      * _*Listens*_ to the custom _doTest_ event fired by the Question component and executes the _showBrowserDetails()_ method callback
      * @event doTest
      * @type {Event}
      */
      showBrowserDetails () {
        /**
        * Tests the current browser make and version against the supported makes and versions.
        * If the browser is supported it executes the passTest method
        * If the browser is not supported because it is out of date it executes the _failTest_ and the _setOldBrowser_ methods
        * If the browser is not supported because it is a bad browser it executes the _failTest_ and the _setBadBrowser_ methods
        * Pass and fail results are rendered in the template depending on these values
        * @public
        * @returns {Boolean} false - Always returns false
        */

        const testResult = unifiedBrowserCheck(this.config.user.browser)

        if (testResult === 'pass') {
          this.passTest()
        } else {
          const [severity, reason] = testResult.split(':')
          if (reason === 'old-browser') {
            this.failTest(this.statusMessage({'desc': 'Browser version is out of date'}))
            this.setOldBrowser()
          } else {
            this.failTest(this.statusMessage({'desc': 'Browser is not supported'}))
            this.setBadBrowser()
          }
          if (severity === 'soft-fail') {
            this.browserSkip = true
          }
        }

        return false
      },

      skipBrowserTest (payload) {
        const skipPayload = this.statusMessage({
          'desc': 'User skipped the browser test',
          'status': 'skip'
        })
        this.skipTest(skipPayload)
      }
    },

    mounted () {
      this.start(this.statusMessage({'status': 'started', 'desc': 'User has started the troubleshooter'}))
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
